import type {
  DraggableProvided,
  DraggableStateSnapshot,
} from "@hello-pangea/dnd";

// Shorter than the library's 0.33s to 0.55s, which delays the placement of the dropped item.
export const DROP_ANIMATION_DURATION = 0.15;

export function withFastDropAnimation(
  provided: DraggableProvided,
  snapshot: DraggableStateSnapshot,
): DraggableProvided {
  const { style } = provided.draggableProps;

  if (!snapshot.dropAnimation || !style || !("position" in style)) {
    return provided;
  }

  const timing = `${DROP_ANIMATION_DURATION}s ${snapshot.dropAnimation.curve}`;

  return {
    ...provided,
    draggableProps: {
      ...provided.draggableProps,
      style: { ...style, transition: `transform ${timing}, opacity ${timing}` },
    },
  };
}
